import React from "react";
import { api } from "@/lib/api";

export const artifactUrl = (name) => `${api.defaults.baseURL}/collaudo-lettore/artifacts/${name}`;
export const usd = (v, d = 4) => (v == null || Number.isNaN(Number(v)) ? "n.d." : `$${Number(v).toFixed(d)}`);
export const secs = (s) => (s == null ? "—" : `${Math.round(Number(s))} s`);
export const ts = (t) => (t ? String(t).slice(0, 19).replace("T", " ") + "Z" : "—");

export const ESITO_META = {
  CORRETTO: { label: "Corretto", cls: "bg-ok-100 text-ok-800 border-ok-300" },
  ERRATO: { label: "Errato", cls: "bg-risk-100 text-risk-800 border-risk-300" },
  OMESSO: { label: "Omesso", cls: "bg-risk-50 text-risk-800 border-risk-300" },
  MANCANTE_SUL_DISEGNO: { label: "Mancante sul disegno", cls: "bg-warn-100 text-warn-800 border-warn-300" },
  NON_DETERMINABILE: { label: "Non determinabile", cls: "bg-muted text-foreground border-border" },
  DISCREPANZA_FASE_A: { label: "Discrepanza FASE A", cls: "bg-tech-100 text-tech-800 border-tech-300" },
  PARZIALE: { label: "Parziale", cls: "bg-warn-50 text-warn-800 border-warn-300" },
};

export const EsitoBadge = ({ esito, testId }) => {
  const m = ESITO_META[esito] || { label: esito || "—", cls: "bg-muted" };
  return <span className={`inline-block px-1.5 py-0.5 border rounded-sm text-[9px] font-bold uppercase whitespace-nowrap ${m.cls}`} data-testid={testId} title={esito}>{m.label}</span>;
};

export const Card = ({ title, subtitle, children, testId, tone = "border-border", right }) => (
  <section className={`border ${tone} bg-white rounded-md shadow-sm`} data-testid={testId}>
    <header className="px-3 py-2 border-b border-border bg-ivory flex flex-wrap items-start justify-between gap-2">
      <div><div className="text-sm font-black tracking-tight">{title}</div>{subtitle && <div className="text-[10px] text-muted-foreground">{subtitle}</div>}</div>
      {right}
    </header>
    <div className="p-3 text-[11px] space-y-2">{children}</div>
  </section>
);

export const KV = ({ k, v, testId }) => <div className="flex justify-between gap-3 border-b border-border/50 py-0.5"><span className="text-muted-foreground">{k}</span><span className="font-mono text-right break-anywhere" data-testid={testId}>{v}</span></div>;

export const bboxShort = (b) => (b ? `${Number(b.x0).toFixed(1)},${Number(b.y0).toFixed(1)}→${Number(b.x1).toFixed(1)},${Number(b.y1).toFixed(1)}%` : "—");

/** Link a uno screenshot registrato: attivo solo se il file e' realmente tra gli artefatti serviti; altrimenti dichiarato non conservato. */
export const ScreenshotLink = ({ path, available }) => {
  const name = path.split("/").pop();
  if (available && !available.has(path)) {
    return <span className="text-muted-foreground line-through" title="registrato nella prova ma file non conservato su disco" data-testid={`cl-shot-missing-${name}`}>{name} (file non conservato)</span>;
  }
  return <a className="link-tech font-bold hover:underline" href={artifactUrl(path)} target="_blank" rel="noreferrer" data-testid={`cl-shot-${name}`}>→ {name}</a>;
};

export const cropUrl = (cid, ev, dpi = 220) => {
  const b = ev.bbox_pct || ev.feature_bbox_pct;
  if (!b) return null;
  return `${api.defaults.baseURL}/collaudo-lettore/cases/${cid}/crop?page=${ev.page || 1}&x0=${b.x0}&y0=${b.y0}&x1=${b.x1}&y1=${b.y1}&dpi=${dpi}`;
};
